module.exports = __webpack_public_path__ + "img/icon-prod-redy.7df4fd31.svg";